import z from 'zod';
import { firmUserStatusValue } from '../../auth';
import { userIdValue } from '../value-objects/ids';
export const firmUserSchema = z.object({
    accountStatus: firmUserStatusValue,
    contactEmail: z.string(),
    firstName: z.string(),
    id: userIdValue,
    isAdmin: z.boolean(),
    lastName: z.string(),
});
export const firmUsersSchema = z.array(firmUserSchema);
//# sourceMappingURL=firm-user.js.map